var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClasseCBlu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.031,
    height: 15.998,
    viewBox: "0 0 213.031 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Unione_11",
    "data-name": "Unione 11",
    d: "M1473.719,23299H1277a3,3,0,0,1-3-3v-10a3,3,0,0,1,3-3h203.117a1.566,1.566,0,0,1,1.21.566l5.344,6.428a1.584,1.584,0,0,1,0,2.01l-5.344,6.428a1.566,1.566,0,0,1-1.21.566Z",
    transform: "translate(-1273.999 -23283.002)",
    fill: "#3260ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasseCBlu);
export default __webpack_public_path__ + "static/media/classeCBlu.528196ec9d0b1fad2a28534e4abe872d.svg";
export { ForwardRef as ReactComponent };